import React, { memo } from 'react'
import { useLoader, LoaderProps } from './useLoader'
import styles from './Loader.module.scss'

const Loader: React.FC<LoaderProps> = (props: LoaderProps) => {
  const {} = useLoader(props)

  return (
    <div className={styles['loader-container']}>
      <img
        src='/img/Loader/loader.gif'
        width={320}
        height={320}
        alt='loader gif'
      />
    </div>
  )
}

export default memo(Loader)
